import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MagacinDropdownDto, MagaciniClient } from '@kodit/core/data-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-magacin-lager-dropdown',
  templateUrl: './magacin-lager-dropdown.component.html',
  styleUrls: ['./magacin-lager-dropdown.component.scss'],
})
export class MagacinLagerDropdownComponent implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();

  options: MagacinDropdownDto[] | undefined = [];
  selectedItem: number;

  @Input() magacinId: number | undefined;
  @Output() onItemChange = new EventEmitter<number>();

  constructor(private _client: MagaciniClient) {}

  ngOnInit(): void {
    this._load();
  }

  private _load() {
    this._subs.add(
      this._client.getDropdown().subscribe((res) => {
        this.options = res.data;

        // defer selectedItem assignment until after options are rendered
        setTimeout(() => {
          this.selectedItem = this.magacinId
            ? Number(this.magacinId)
            : this.options[0]?.id;

          this.onItemChange.emit(this.selectedItem);
        });
      })
    );
  }

  itemChanged(event: any) {
    this.onItemChange.emit(this.selectedItem);
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
